import { Switch } from '@material-ui/core';
import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

const Toggle = styled(Switch)`
  .MuiSwitch-thumb {
    color: #f1f1f1;
  }

  .MuiSwitch-track {
    background-color: #221f1f;
    opacity: 0.26;
  }

  .Mui-checked {
    .MuiSwitch-thumb {
      color: ${ColorPalette.HEX.OriolesOrange};
    }
  }

  .Mui-checked + .MuiSwitch-track {
    background-color: ${ColorPalette.HEX.VeryPaleOrange} !important;
    opacity: 1;
  }
`;

export default Toggle;
